import React from "react";
import { Crown } from "lucide-react";
import { useAuth } from "../lib/auth";

export const useChampionId = () => useAuth().user?.pw_champion_id || null;

export const ChampionCrown = ({ className = "top-0.5 left-1/2 -translate-x-1/2 w-[30%] max-w-[22px] min-w-[10px] aspect-square", testId = "pw-champion-crown" }) => (
  <span data-testid={testId} title="Reigning Promotion Wars champion"
        className={`absolute z-20 pointer-events-none flex items-center justify-center ${className}`}>
    <Crown className="w-full h-full" fill="#FFD700" strokeWidth={1.5}
           style={{ color: "#B8860B", filter: "drop-shadow(0 0 4px #FFD700) drop-shadow(0 1px 1px #000)" }} />
  </span>
);
